module.exports = __webpack_public_path__ + "assets/img/dfa-oit.fd9c97ea.png";